import React from 'react';
import { ProfileCircle } from './ProfileCircle';

interface Responder {
  id: string;
  photoURL: string;
  displayName: string;
  isSuperKonnected?: boolean;
}

interface ProfileCircleStackProps {
  responders: Responder[];
  /** Max aantal zichtbare avatars voor de overflow badge verschijnt. Default: 9 */
  maxVisible?: number;
  className?: string;
}

/**
 * ProfileCircleStack Component
 * Toont gestapelde avatars. Bij meer dan maxVisible verschijnt "+N".
 * Geen scores, geen ranking — puur wie heeft gereageerd.
 */
export const ProfileCircleStack: React.FC<ProfileCircleStackProps> = ({ 
  responders,
  maxVisible = 9,
  className = '' 
}) => {
  if (!responders || responders.length === 0) {
    return null;
  }

  const visible = responders.slice(0, maxVisible);
  const overflow = responders.length - visible.length;

  return (
    <div className={`flex -space-x-2 items-center ${className}`}>
      {visible.map((responder) => (
        <ProfileCircle
          key={responder.id}
          photoURL={responder.photoURL}
          displayName={responder.displayName}
          className="ring-2 ring-white"
          isSuperKonnected={responder.isSuperKonnected}
        />
      ))}
      {overflow > 0 && (
        <div
          className="w-6 h-6 rounded-full ring-2 ring-white flex items-center justify-center text-[9px] font-medium"
          style={{ background: '#E8EDE9', color: '#4A6358' }}
          aria-label={`${overflow} meer`}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
};

export default ProfileCircleStack;
